var rich_content_viewer_default = {
  "fontElementMap": "WnYTp",
  "wrapper": "o8Ch2",
  "pluginContainerMobile": "rLzoa",
  "viewer": "lclD-",
  "android": "as2nh",
  "rootedTraversedContent": "vxtBU",
  "atomic": "_1t0G8",
  "toolbar": "FfT07",
  "block": "_4MmFh"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
